import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faMagnifyingGlassChart,
  faSitemap,
  faPenRuler,
  faRocket,
  faArrowsSpin,
} from "@fortawesome/free-solid-svg-icons";
import "./Process.css";

const steps = [
  {
    title: "Discovery and alignment",
    desc: "We map your goals, target audience, and constraints to align business priorities with execution.",
    icon: faComments,
  },
  {
    title: "Audit and diagnosis",
    desc: "We assess website, funnel, and data setup to identify bottlenecks and the highest-impact opportunities.",
    icon: faMagnifyingGlassChart,
  },
  {
    title: "Strategy and roadmap",
    desc: "We define deliverables, milestones, and KPIs so scope, timelines, and priorities stay clear.",
    icon: faSitemap,
  },
  {
    title: "Build and implementation",
    desc: "We execute design, development, and growth setup with emphasis on speed, usability, and conversion.",
    icon: faPenRuler,
  },
  {
    title: "Launch and QA",
    desc: "Before launch, we validate responsiveness, tracking, SEO basics, and critical user flows.",
    icon: faRocket,
  },
  {
    title: "Optimization cycle",
    desc: "Post-launch, we monitor outcomes and continuously refine for better lead quality and efficiency.",
    icon: faArrowsSpin,
  },
];

const Process = () => {
  return (
    <section className="about-process">
      <div className="about-process-wrap">
        <header className="about-process-head">
          <span className="about-process-kicker">Our process</span>
          <h2>How we execute every engagement</h2>
          <p>
            A structured workflow that keeps decisions transparent, execution
            focused, and outcomes measurable.
          </p>
        </header>

        <div className="about-process-list">
          {steps.map((step, index) => (
            <div className="about-process-item" key={index}>
              <div className="about-process-icon">
                <FontAwesomeIcon icon={step.icon} />
              </div>

              <div className="about-process-content">
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
